export const yellowColor = '#F6C035';
export const redColor = '#F04438';
export const grayColor100 = '#F5F7F6';
export const grayColor600 = '#656766';
export const grayColor700 = '#525453';
export const grayColor300 = '#D9DDDB';
export const gray = '#D7E1DC';
export const whiteColor = '#FFFFFF';
export const blackColor = '#000000';
